import { Tabs, TabsProps } from 'antd';

export type TabsAtomProps = TabsProps;

const TabsAtom = Tabs;

export default TabsAtom;
